/**
 * Location type values
 */
export enum LocationTypeEnum {
	OFFICE = 'office',
	WORKSHOP = 'workshop',
	BODYSHOP = 'bodyshop',
	PARKING_LOT = 'parking_lot',
	OTHER = 'other',
}
